module.exports = __webpack_public_path__ + "media/images/railslove_dark-b97a4ca974f22dd05a7b602aee5c0d46.png";